import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as selector from '../../barbers/selector';
import { fullName } from '../../../common/helpers/users';
import Switch from '../../../common/Switch';

class SelectBarber extends Component {
  onBarberSelected = (e) => {
    this.props.selectBarber(e.target.value);
  };

  render() {
    const options = this.props.barbers.map(barber => (
      <option
        key={barber.id}
        value={barber.id}
      >
        {fullName(barber)}
      </option>
    ));
    return (
      <div className="layout__item medium-and-up-mb--">
        <div className="o-flexbox">
          <div className="o-flexbox u-flex-1 u-pr-">
            <div className="c-label-new u-mb--">
              Barber
            </div>
            <select
              className="c-select"
              value={this.props.selectedBarber}
              onChange={this.onBarberSelected}
              disabled={!this.props.canModifyAppointments}
              data-automation-id="select:barbers"
            >
              <option key={-1} value={-1}>Choose a barber</option>
              {options}
            </select>
          </div>
          <div className="u-mt-">
            <Switch
              checked={this.props.bookedWithAnyBarber}
              onChange={this.props.onAnyBarberChange}
              label="Any"
              display-if={this.props.canModifyAppointments}
            />
          </div>
        </div>
      </div>
    );
  }
}

SelectBarber.propTypes = {
  selectBarber: PropTypes.func.isRequired,
  selectedBarber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  barbers: PropTypes.arrayOf(PropTypes.object),
  bookedWithAnyBarber: PropTypes.bool.isRequired,
  onAnyBarberChange: PropTypes.func.isRequired,
  canModifyAppointments: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  barbers: selector.getAll(state),
});

export default connect(mapStateToProps, null)(SelectBarber);
